import qv from '~/url_options';

export const autoresultsParams = {
  auto_results_percentile_thresholds_per_tenement_area:
    qv.AUTO_RESULTS_PERCENTILE_THRESHOLDS_PER_TENEMENT_AREA,
  auto_results_min_count_per_tenement: qv.AUTO_RESULTS_MIN_COUNT_PER_TENEMENT,
  auto_results_max_count_per_tenement: qv.AUTO_RESULTS_MAX_COUNT_PER_TENEMENT,
};

export const MIN_PG_INTERSECTION_AREA = 2;
